import './sentry';
import './posthog';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Sentry } from './sentry';
import { App } from './App';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="p-8 text-foreground-soft">Something went wrong. Refresh the page.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
